import { Heading as ChakraHeading } from "@chakra-ui/react"
import { IHeadingProps } from "./HeadingTypes"

const Heading: React.FC<IHeadingProps> = ({
  title,
  variant,
  size = "base",
  className,
}) => {
  return (
    <ChakraHeading className={className} variant={variant} size={size}>
      {title}
    </ChakraHeading>
  )
}

export default Heading
